import OrderablesListPanel from './orderables-list-panel.vue';
import DeleteOrderableModal from './delete-orderable-modal.vue';
import CreateOrderableModal from './create-orderable-modal.vue';
export default{
  OrderablesListPanel,
  DeleteOrderableModal,
  CreateOrderableModal
}